import { ca } from '@cian/analytics';

export function trackMoreInfoClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'GoTo',
    label: 'MoreInfo',
  });
}
